import resume from './resume.js'
import referralCode from './referral-code.js'
import pushOpen from './push-open.js'
import deeplink from './deeplink.js'
import mobileAppInstalled from './mobile-app-installed.js'

// list of all persistent handlers
export default [
  resume,
  referralCode,
  pushOpen,
  deeplink,
  mobileAppInstalled,
]
